import React from 'react'

export const constants = {
    featureInfo:
        <React.Fragment>
             Please note, claims reporting will be based on the adjustment 
            occurring within a check that has a remit date within the report 
            date range. Therefore, this report may display service dates outside 
            of the selected date range.
        </React.Fragment>

}

